import React, { useState, useRef } from 'react';
import { importService } from '../services/importService';
import './ImportButton.css';
import ImportResultModal from './ImportResultModal';

const ImportButton = ({ 
  type = 'products',
  label = 'Importer Produits',
  icon = 'fas fa-file-import',
  className = '',
  onSuccess,
  onError 
}) => {
  const [isImporting, setIsImporting] = useState(false);
  const [importProgress, setImportProgress] = useState(0);
  const [result, setResult] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const fileInputRef = useRef(null);

  const handleImport = async (file) => {
    if (!file) return;

    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'text/csv'
    ];

    if (!allowedTypes.includes(file.type) && !/\.(xlsx|xls|csv)$/i.test(file.name || '')) {
      const error = 'Veuillez sélectionner un fichier Excel (.xlsx, .xls) ou CSV';
      if (onError) onError(error);
      else alert(error);
      return;
    }

    setIsImporting(true);
    setImportProgress(0);

    try {
      const result = await importService.importProducts(file, (progress) => {
        setImportProgress(progress);
      });

      setResult(result);
      setModalOpen(true);

      const { imported = 0, errors = 0, details = [] } = result;
      result.downloadErrorsCsv = () => {
        if (!details || details.length === 0) return;
        const rows = [['Ligne','Produit','Erreur']];
        details.forEach(d => {
          if (d.error) {
            rows.push([ (d.index ?? '') + 2, d.product || '', d.error || '' ]);
          }
        });
        const csvContent = rows.map(r => r.map(c => `"${String(c ?? '').replace(/"/g,'""')}"`).join(',')).join('\n');
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url; a.download = `erreurs-import-${Date.now()}.csv`; document.body.appendChild(a); a.click(); setTimeout(() => { URL.revokeObjectURL(url); document.body.removeChild(a); }, 100);
      };

      if (onSuccess) onSuccess(result);

    } catch (error) {
      console.error('Erreur d\'import:', error);
      if (onError) {
        onError(error.message || 'Erreur lors de l\'import');
      }
    } finally {
      setIsImporting(false);
      setImportProgress(0);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) handleImport(file);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const getButtonLabel = () => {
    if (isImporting) return `Import... ${importProgress}%`;
    return label;
  };

  return (
    <>
      <ImportResultModal open={modalOpen} onClose={() => setModalOpen(false)} result={result} />
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx,.xls,.csv"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
      <button
        className={`import-button ${className}`}
        onClick={handleButtonClick}
        disabled={isImporting}
        title={getButtonLabel()}
      >
        {isImporting ? (
          <i className="fas fa-spinner fa-spin"></i>
        ) : (
          <i className={icon}></i>
        )}
        <span>{getButtonLabel()}</span>
        {isImporting && (
          <div className="import-progress">
            <div 
              className="import-progress-bar" 
              style={{ width: `${importProgress}%` }}
            ></div>
          </div>
        )}
      </button>
    </>
  );
};

export default ImportButton;
